export const SPINNER = `
<span class="loader"></span>
`

export const SUCCESS_MSG = 'Contacto efectuado com sucesso'
export const ERRORA_MSG = 'Ocorreu um erro, tente novamente mais tarde '
